import * as yup from "yup";

const deductionsSchema = yup.object().shape({
  code: yup.string().required("Required"),
  amountType: yup.string().required("Required"),
  // maxAmountType: yup.string().required("Required"),
  amount: yup
    .string()
    .required("Required")
    .test({
      name: "number-validation",
      test: (value, ctx) => {
        if (!value) return ctx.createError({ message: "Required" });
        let result;
        try {
          result = parseFloat(value);
        } catch {
          //
        }
        if (!result) return ctx.createError({ message: "Invalid amount" });
        return true;
      },
    }),
  // maxAmount: yup
  //   .string()
  //   .required("Required")
  //   .test({
  //     name: "number-validation2",
  //     test: (value, ctx) => {
  //       if (!value) return ctx.createError({ message: "Required" });
  //       let result;
  //       try {
  //         result = parseFloat(value);
  //       } catch {
  //         //
  //       }
  //       if (!result) return ctx.createError({ message: "Invalid amount" });
  //       return true;
  //     },
  //   }),
  option: yup.object().nullable().required("Required"),
});

export default deductionsSchema;
